// assets/product-gifting.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductGiftingRefs
 * @property {HTMLInputElement} giftYes - The "Yes" radio button.
 * @property {HTMLInputElement} giftNo - The "No" radio button.
 * @property {HTMLElement} giftContent - The gift content container.
 * @property {HTMLTextAreaElement} giftNote - The gift note textarea.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product gifting options
 * @extends Component<ProductGiftingRefs>
 */
class ProductGifting extends Component {
  connectedCallback() {
    super.connectedCallback();
    // Initialize state based on checked radio
    this.#updateGiftContent();
  }

  handleGiftToggle() {
    this.#updateGiftContent();
  }

  handleNoteInput() {
    this.#updateCharacterCount();
  }

  #updateGiftContent() {
    const { giftYes, giftContent, giftNote } = this.refs;
    
    if (!giftYes || !giftContent) return;

    const isGift = giftYes.checked;
    
    if (isGift) {
      giftContent.classList.remove('hidden');
      // Focus the textarea when revealed
      if (giftNote) {
        setTimeout(() => {
          giftNote.focus();
        }, 100);
      }
    } else {
      giftContent.classList.add('hidden');
      // Clear the note when hidden
      if (giftNote) {
        giftNote.value = '';
        this.#updateCharacterCount();
      }
    }
  }

  #updateCharacterCount() {
    const { characterCount, giftNote } = this.refs;
    
    if (!characterCount || !giftNote) return;

    const currentLength = giftNote.value.length;
    const maxLength = parseInt(characterCount.getAttribute('data-max') || '250', 10);
    
    const template = characterCount.getAttribute('data-template') || '[current] / [max]';
    const updatedText = template
      .replace('[current]', currentLength.toString())
      .replace('[max]', maxLength.toString());
    
    characterCount.textContent = updatedText;
  }
}

customElements.define('product-gifting-component', ProductGifting);
